export default "__VITE_ASSET__CM7gExK8__"